import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Leaf, BookOpen, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const pillars = [{
  icon: <Leaf className="w-10 h-10 text-sage" data-id="element-213" />,
  title: 'Ingredientes 100% Naturales',
  description: 'Aprende a usar aceites, ceras y plantas medicinales puras para nutrir tu piel.'
}, {
  icon: <BookOpen className="w-10 h-10 text-sage" data-id="element-214" />,
  title: 'Recetas Paso a Paso',
  description: 'Instrucciones claras y sencillas, diseñadas para que cualquier persona pueda seguirlas.'
}, {
  icon: <CheckCircle className="w-10 h-10 text-sage" data-id="element-215" />,
  title: 'Resultados Comprobados',
  description: 'Fórmulas basadas en la medicina tradicional que han funcionado por generaciones.'
}];
export function SolutionSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <SectionWrapper id="solucion" className="px-4 md:px-12 max-w-6xl mx-auto" data-id="element-216">
      <div className="text-center mb-16" data-id="element-217">
        <h2 className="text-3xl md:text-5xl font-playfair text-forest mb-6" data-id="element-218">
          Recupera el poder de la naturaleza
        </h2>
        <p className="text-lg md:text-xl text-brown/80 max-w-3xl mx-auto leading-relaxed" data-id="element-219">
          Esta guía te enseñará desde cero cómo transformar ingredientes
          naturales y accesibles en pomadas terapéuticas de alta calidad, hechas
          con tus propias manos.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-220">
        {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.2
      }} className="bg-card p-8 rounded-3xl shadow-warm border border-sage/20 text-center group hover:-translate-y-2 transition-transform duration-300" data-id="element-221">
            <div className="w-20 h-20 mx-auto bg-sage/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-222">
              {pillar.icon}
            </div>
            <h3 className="text-2xl font-playfair text-forest mb-4" data-id="element-223">
              {pillar.title}
            </h3>
            <p className="text-brown/80 leading-relaxed" data-id="element-224">
              {pillar.description}
            </p>
          </motion.div>)}
      </div>

      <div className="text-center" data-id="element-225">
        <button onClick={scrollToPricing} className="text-amber font-semibold hover:text-forest transition-colors border-b-2 border-amber hover:border-forest pb-1" data-id="element-226">
          Ver Precio Especial
        </button>
      </div>
    </SectionWrapper>;
}